/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_DownloadInputs */

const en_document_download = /** @type {(inputs: Document_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const id_document_download = /** @type {(inputs: Document_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh`)
};

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const es_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const fr_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const de_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const ja_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const zh_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const ar_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const it_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const ru_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const pt_document_download = en_document_download;

/** @type {(inputs: Document_DownloadInputs) => LocalizedString} */
const ko_document_download = en_document_download;

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Document_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_download = /** @type {((inputs?: Document_DownloadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_DownloadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_download(inputs)
	if (locale === "es") return es_document_download(inputs)
	if (locale === "fr") return fr_document_download(inputs)
	if (locale === "de") return de_document_download(inputs)
	if (locale === "ja") return ja_document_download(inputs)
	if (locale === "zh") return zh_document_download(inputs)
	if (locale === "ar") return ar_document_download(inputs)
	if (locale === "id") return id_document_download(inputs)
	if (locale === "it") return it_document_download(inputs)
	if (locale === "ru") return ru_document_download(inputs)
	if (locale === "pt") return pt_document_download(inputs)
	return ko_document_download(inputs)
});